const neighborhoodCardGrid = {
  displayField: 'header',
  name: 'Neighborhood Card Grid',
  description: 'Grid for showing Featured Neighborhoods',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'neighborhoods',
      name: 'neighborhoods',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 5 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'neighborhoodSingle' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'ctaUrl',
      name: 'ctaUrl',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'neighborhoodCardGrid',
    version: 8,
    updatedAt: '2023-08-03T14:18:41.129Z'
  }
};
export default neighborhoodCardGrid;